import { AlertData } from 'src/app/core/services/alert.service';

/**
 * The alert editor's payload is sent **url-encoded**, not JSON, with PHP-style
 * bracket keys for nested objects and arrays (`filters[0][property_uri]=…`).
 *
 * Null and undefined values are **skipped**, which is load-bearing: the backend
 * treats an absent key differently from an empty one.
 */
export const alertToUrlEncoded = (alert: AlertData): string => {
  const pairs: string[] = [];

  const encode = (value: unknown, key: string): void => {
    if (value == null) return;

    if (typeof value === 'object') {
      serialize(value as Record<string, unknown>, key);
      return;
    }

    pairs.push(
      `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    );
  };

  const serialize = (obj: Record<string, unknown>, parentKey = ''): void => {
    Object.entries(obj).forEach(([key, value]) => {
      const compositeKey = parentKey ? `${parentKey}[${key}]` : key;

      if (Array.isArray(value)) {
        value.forEach((item, index) =>
          encode(item, `${compositeKey}[${index}]`),
        );
      } else if (typeof value === 'object' && value !== null) {
        serialize(value as Record<string, unknown>, compositeKey);
      } else {
        encode(value, compositeKey);
      }
    });
  };

  serialize(alert as unknown as Record<string, unknown>);

  return pairs.join('&');
};
